import { Button, Modal } from 'react-daisyui';
import { Trans, useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
import { SyncConversationsEnum } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.enum.ts';
import './SyncConversationsQuestion.styles.scss';

export default function SyncConversationsQuestion() {
  const { syncConversationsStatus, setSyncConversationsStatus } =
    useModalsContext();
  const { t } = useTranslation('dashboard/dashboard');

  return (
    <Modal
      className="SyncConversationsQuestion w-full max-w-4xl"
      open={syncConversationsStatus === SyncConversationsEnum.QUESTION}
    >
      <div className="SyncConversationsQuestion__Container">
        <div className="SyncConversationsQuestion__Container__Center">
          <img
            src={'/images/sync/syncMobilePhone.png'}
            alt="syncMobilePhone"
            className="SyncConversationsQuestion__Container__Image"
          />
          <h1 className="SyncConversationsQuestion__Container__Title">
            {t('components.modals.SyncConversations.question.title')}
          </h1>
          <p>
            <Trans
              i18nKey={t('components.modals.SyncConversations.question.text1')}
              components={[
                <span className="SyncConversationsQuestion__Container__Bold" />,
              ]}
            />
          </p>
          <p>
            <Trans
              i18nKey={t('components.modals.SyncConversations.question.text2')}
              components={[
                <strong className="SyncConversationsQuestion__Container__Bold" />,
              ]}
            />
          </p>
          <strong className="SyncConversationsQuestion__Container__Bold__Large">
            {t('components.modals.SyncConversations.question.question')}
          </strong>
          <div className="SyncConversationsQuestion__Container__Bottom">
            <Button
              onClick={() => {
                setSyncConversationsStatus(SyncConversationsEnum.SELECTING);
              }}
              color="primary"
              className="SyncConversationsQuestion__Container__Bottom__Button text-base-100"
            >
              {t('components.modals.SyncConversations.question.button')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
